module.exports = __webpack_public_path__ + "img/892bc02.svg";